// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"818":"auth","826":"index"}[chunkId] + "." + {"818":"22896c39","826":"e83e8372"}[chunkId] + ".css";
};